import { TextField } from '@material-ui/core';
import { StandardTextFieldProps } from '@material-ui/core/TextField';
import React, { useState } from 'react';

export const MIN_LENGTH = 3;
export const MAX_LENGTH = 16;

export function sanitizeOrganizationId(id: any) {
  return id
    ? id
        .toString()
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, '')
        .substr(0, MAX_LENGTH)
    : '';
}

export function getOrganizationIdError(id: string) {
  if (!id) {
    return 'Required';
  } else if (id.length < MIN_LENGTH) {
    return `Min length ${MIN_LENGTH}`;
  } else {
    return '';
  }
}

interface Props extends StandardTextFieldProps {
  onChangeValue: (value: string, error: string) => void;
}

const VanityDomainTextField = ({ onChangeValue, value, ...props }: Props) => {
  const [error, setError] = useState<string>('');

  const handleChangeValue = (event: any) => {
    const value: string = sanitizeOrganizationId(event.target.value);
    const error = getOrganizationIdError(value);

    setError(error);
    onChangeValue(value, error);
  };

  return (
    <TextField
      id="vanity-domain-url"
      label="Vanity Domain Url"
      value={sanitizeOrganizationId(value)}
      onChange={handleChangeValue}
      error={error !== ''}
      helperText={
        error
          ? error
          : 'A unique 3 - 16 char alphanumeric ID for your organization that will also appear as part of the url.'
      }
      InputProps={{
        startAdornment: 'https://',
        endAdornment: '.apps.us.jupiterone.io',
      }}
      {...props}
    />
  );
};

export default VanityDomainTextField;
